const toggleButton = document.getElementById('site-navigation-button');
const navigationContent = document.getElementById('site-navigation-content');

const toggleButtonActiveClassName = 'hamburger--active';
const navigationContentActiveClassName = 'navigation__content-wrapper--active';

if (toggleButton) {
    toggleButton.addEventListener('click', e => {
        const isActive = toggleButton.getAttribute('aria-expanded') === 'true';
        if (isActive) {
            navigationContent.classList.remove(navigationContentActiveClassName);
            toggleButton.classList.remove(toggleButtonActiveClassName);
            toggleButton.setAttribute('aria-expanded', 'false');
        } else {
            navigationContent.classList.add(navigationContentActiveClassName);
            toggleButton.classList.add(toggleButtonActiveClassName);
            toggleButton.setAttribute('aria-expanded', 'true');
        }
    });
}

const menuItemsWithFlyouts = Array.from(document.querySelectorAll('.menu__item--has-descendants'));
const menuItemActiveClass = 'menu__item--active';

menuItemsWithFlyouts.forEach(item => {
    item.addEventListener('click', e => {
        // for fine pointers with hover states (non-touch devices), let the click go through
        if (window.matchMedia('(pointer: fine)').matches) return;

        // close other active items
        menuItemsWithFlyouts
            .filter(el => el !== item)
            .forEach(el => el.classList.remove(menuItemActiveClass));

        // let the click go through if the item is already active
        const isActive = item.classList.contains(menuItemActiveClass);
        if (isActive) return;

        // activate (open) the clicked node
        item.classList.add(menuItemActiveClass);
        e.preventDefault();
    });
});
